<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { UserResponseDto } from '@clearbanc/baus-sdk';
import { useUserInviteManagement } from '@/composables/user-invite-management';
import { useToast } from '@/composables/useToast';
import { userDoesNotHaveLogin } from '@/utils/user-helper';

import Button from 'primevue/button';

const toast = useToast();

const { sendInvite, loadingUserInvite } = useUserInviteManagement();

const props = defineProps<{
  label: string;
  user: UserResponseDto;
}>();

const isUserWithoutLogin = computed<boolean>(() => {
  return userDoesNotHaveLogin(props.user);
});

async function sendInitialInvite(): Promise<void> {
  await sendInvite(props.user);
  toast.success(`Sent invite to ${props.user.fullName}`);
}
</script>

<template>
  <Button
    v-if="isUserWithoutLogin"
    :label="props.label"
    @click="sendInitialInvite()"
    :loading="loadingUserInvite"
    outlined
    class="p-button-outlined invite-user-button"
  ></Button>
</template>

<style lang="less" scoped>
.invite-user-button {
  font-size: 0.75rem;
  padding: 0.2rem 1rem;
  white-space: nowrap;
}
</style>
